<template>
  <div>
    <div class="p-4 bg-secondary text-white">
      <h4 class="uppercase mb-0">{{ $t('titles.firearm') }}</h4>
    </div>
    <div class="p-4">
      <div class="flex flex-col lg:flex-row lg:flex-wrap">
        <div class="form-group w-full lg:w-1/2 lg:pr-3">
          <label class="form-label">
            <span>{{ $t("initialVelocity.label") }}</span>
            <i class="fas fa-question-circle text-primary"
              v-tippy
              :content=initialVelocityHelpText
              data-tippy-animation="fade"
              data-tippy-arrow="true">
            </i>
          </label>
          <div class="input-group">
            <input
              name="turret_customization[initial_velocity]"
              type="number"
              step="any"
              class="form-control"
              :class="{'error': errors.has('turret_customization[initial_velocity]')}"
              :placeholder="$t('initialVelocity.placeholder')"
              :data-vv-as="$t('initialVelocity.label')"
              v-validate=initialVelocityValidation
              v-model="initialVelocity">
            </input>
            <div class="input-group-append">
              <div class="input-group-text text-xs uppercase">{{ this.isImperial ? "FT/S" : "M/S" }}</div>
            </div>
          </div>
          <span class="form-hint error">{{ errors.first("turret_customization[initial_velocity]") }}</span>
        </div>

        <div class="form-group w-full lg:w-1/2 lg:pr-3">
          <label class="form-label">
            <span>{{ $t("zeroRange.label") }}</span>
            <i class="fas fa-question-circle text-primary"
              v-tippy="{ arrow : true,  animation : 'shift-away'}"
              :content=zeroRangeHelpText>
            </i>
          </label>
          <div class="input-group">
              <select
                class="form-control with-caret"
                name="turret_customization[zero_range]"
                v-model="zeroRange"
                v-validate="'required|between:0,2000'"
                :placeholder="$t('zeroRange.placeholder')">
                <option :value="option" v-for="option in zeroRangeOptions">{{option}}</option>
              </select>
            </input>
            <div class="input-group-append">
              <div class="input-group-text text-xs uppercase">{{ this.isImperial ? $t('generic.yards') : $t('generic.meters') }}</div>
            </div>
          </div>
          <span class="form-hint error">{{ errors.first("turret_customization[zero_range]") }}</span>
        </div>
      </div>
      <div class="p-4 bg-gray-100 text-center border rounded text-sm text-gray-700">
        {{ $t("firearm.formHelper") }}
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex"
const { mapGetters } = createNamespacedHelpers("turretCustomizer")

export default {
  
  computed: {
    ...mapGetters([
      "isImperial"
    ]),
    initialVelocity: {
      get() { return this.$store.getters["turretCustomizer/initialVelocity"] },
      set(newInitialVelocity) { this.$store.dispatch("turretCustomizer/updateInitialVelocity", newInitialVelocity) }
    },
    zeroRange: {
      get() { return this.$store.getters["turretCustomizer/zeroRange"] },
      set(newZeroRange) { this.$store.dispatch("turretCustomizer/updateZeroRange", newZeroRange) }
    },
    initialVelocityHelpText() {
      return this.isImperial ? this.$t("initialVelocity.helpTextImperial") : this.$t("initialVelocity.helpTextMetric")
    },
    initialVelocityValidation() {
      return this.isImperial ? { required: true, between: [500, 4600] } : { required: true, between: [300, 1400] }
    },
    zeroRangeHelpText() {
      return this.isImperial ? this.$t("zeroRange.helpTextImperial") : this.$t("zeroRange.helpTextMetric")
    },
    zeroRangeOptions() {
      return [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]
    }
  }
}
</script>
